import React from "react";
import Modal from "../../../../../shared/modal";
import PropTypes from "prop-types";

import styles from "./styles.css";
import CloseImage from "./images/close.svg";
import StepOne from "./images/explore-cars.png";
import StepTwo from "./images/book-slot.png";
import StepThree from "./images/test-drive.png";

const TestDriveYourDreamCarPopup = ({onClick}) => {
    return (
        <Modal isOpen={true}>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.headerWrapper"}>
                    <p styleName={"styles.heading"}>Test drive your dream car!</p>
                    <img src={CloseImage} onClick={onClick} />
                </div>
                <p styleName={"styles.subHeading"}>You can book a test drive on select cars wherever mentioned. You can always buy all our cars with 7-Day return, 100% money-back guarantee.</p>
                <p styleName={"styles.stepsTitle"}>Steps to book your free test drive</p>
                <div styleName={"styles.stepsWrapper"}>
                    <div styleName={"styles.steps"}>
                        <img src={StepOne} />
                        <p styleName={"styles.stepsHeading"}>Explore cars</p>
                        <p styleName={"styles.stepsSubHeading"}>Browse cars available for test drive</p>
                    </div>
                    <div styleName={"styles.steps"}>
                        <img src={StepTwo} />
                        <p styleName={"styles.stepsHeading"}>Book a slot</p>
                        <p styleName={"styles.stepsSubHeading"}>Opt your preferred time slot</p>
                    </div>
                    <div styleName={"styles.steps"}>
                        <img src={StepThree} />
                        <p styleName={"styles.stepsHeading"}>Test drive</p>
                        <p styleName={"styles.stepsSubHeading"}>Visit the hub for a guided test drive </p>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

TestDriveYourDreamCarPopup.propTypes = {
    onClick: PropTypes.func
};
export default TestDriveYourDreamCarPopup;
